export let MOCK_REORDER_ALERTS = [
  {
    id: "alert-101",
    productId: "prod-101",
    productName: "XLPE Armoured Cable 4C x 16 sqmm",
    partNumber: "MC-XLPE-416",
    warehouse: "Warehouse Bangalore",
    category: "Cables & Wires",
    availableStock: 0, // Critical shortage
    reorderQuantity: 500,
    status: "New",
    lastUpdated: "2026-08-04T10:00:00Z",
    snoozeUntil: null,
  },
  {
    id: "alert-102",
    productId: "prod-102",
    productName: "Copper Cable Lugs 50 sqmm",
    partNumber: "KV-LUG-50",
    warehouse: "Peelamedu Depot",
    category: "Terminations",
    availableStock: 18,
    reorderQuantity: 40,
    status: "Snoozed",
    lastUpdated: "2026-07-20T11:30:00Z",
    snoozeUntil: "2026-08-15T00:00:00Z", // Future snooze relative to 2026-08-05. Hidden from New unless status filter is 'Snoozed'.
  },
  {
    id: "alert-103",
    productId: "prod-103",
    productName: "Changeover Switch 63A",
    partNumber: "MC-CHG-63",
    warehouse: "Warehouse Mysore",
    category: "Switchgears",
    availableStock: 12,
    reorderQuantity: 15,
    status: "New",
    lastUpdated: "2026-08-03T15:20:00Z",
    snoozeUntil: null,
  },
  {
    id: "alert-104",
    productId: "prod-104",
    productName: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    warehouse: "Coimbatore Central Warehouse",
    category: "Switchgears",
    availableStock: 200, // Available == Reorder threshold
    reorderQuantity: 200,
    status: "Acknowledged",
    lastUpdated: "2026-08-01T09:45:00Z",
    snoozeUntil: null,
  },
  {
    id: "alert-105",
    productId: "prod-105",
    productName: "LED Panel Light 15W 6500K",
    partNumber: "LT-PAN-15W",
    warehouse: "Warehouse Bangalore",
    category: "Lighting Fixtures",
    availableStock: 45,
    reorderQuantity: 100,
    status: "Snoozed",
    lastUpdated: "2026-07-15T08:00:00Z",
    snoozeUntil: "2026-07-24T00:00:00Z", // Expired snooze. Automatically resurfaces as New.
  },

  // Auto clear simulation: Products that exceed Reorder Qty.
  // These should be filtered out and NEVER appear in the table.
  {
    id: "alert-106",
    productId: "prod-106",
    productName: "Gate Valve DN100 PN16",
    partNumber: "FL-GVAL-100",
    warehouse: "Warehouse Chennai",
    category: "Valves & Fittings",
    availableStock: 120, // Available > Reorder
    reorderQuantity: 50,
    status: "New",
    lastUpdated: "2026-08-04T12:00:00Z",
    snoozeUntil: null,
  },
];
